/* istanbul ignore file */
import isEqual from 'react-fast-compare';
export const setIfNotEqual = (s, k, v) => {
    if (isEqual(s[k], v))
        return;
    s[k] = v;
};
//# sourceMappingURL=setIfNotEqual.js.map